// values are in hex, comments in decimal

export enum ETelemetryMessageType {
    response = 1, // 1
    currentState = 49, //'D3', // 211
    // batteryLevels = '54', // 84
    batteryLevels = 50, // check if these are correct.. the log files have 50
    tankPressures = 51, // '86' // 134
    chamberInjectorPressures = 52, //'98', // 152
    valveStates = '4A', // 74
    armedStatus = 'CD', // 205
}
